import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Star, ShieldCheck, Clock } from 'lucide-react';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 10
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 2;
          minutes = 45;
          seconds = 10;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-16 px-4 bg-brand-light border-b-8 border-brand-green scroll-mt-4" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <div className="text-center mb-8" data-id="element-125">
          <p className="text-sm font-black text-brand-red uppercase tracking-widest mb-2" data-id="element-126">
            OFFERTA SPECIALE — PACK COMPLETO 6 IN 1
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-brand-dark mb-6 tracking-tight uppercase leading-tight" data-id="element-127">
            Accedi al sistema ora e trasforma il tuo metodo di insegnamento oggi
            stesso.
          </h2>
          <a href="https://yoga-pro.impultienda.ar/checkout" className="block cursor-pointer" data-id="element-128">
            <img src="https://cdn.magicpatterns.com/uploads/qeCtvuEY2ns3jiGzLBrkca/ChatGPT-Image-24-jun-2026_-10_01_02-p.m..webp" alt="YOGA PRO 6-in-1 Box Set" className="w-full max-w-lg mx-auto object-contain drop-shadow-2xl mb-8 hover:scale-[1.02] transition-transform duration-500" data-id="element-129" />
          </a>
        </div>

        <div className="bg-white border-4 border-brand-red rounded-2xl p-6 sm:p-10 text-center relative mb-8 shadow-2xl" data-id="element-130">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-red text-white px-6 py-2 rounded-full text-sm sm:text-base font-black shadow-lg whitespace-nowrap uppercase tracking-wider" data-id="element-131">
            🧘 YOGA PRO™ — Box Set Completo 6 in 1
          </div>

          <div className="mb-8 mt-4" data-id="element-132">
            <p className="text-lg font-bold text-gray-500 mb-2" data-id="element-133">
              Prezzo Normale: <span className="line-through" data-id="element-134">€97</span>
            </p>
            <p className="text-xl sm:text-2xl font-black text-brand-red mb-4 uppercase tracking-wide" data-id="element-135">
              🔥 72% DI SCONTO — OFFERTA DI LANCIO
            </p>
            <p className="text-7xl sm:text-8xl font-black text-brand-dark mb-2 tracking-tighter" data-id="element-136">
              €27
            </p>
            <p className="text-sm font-bold text-gray-500 uppercase tracking-widest" data-id="element-137">
              Paga nella tua valuta locale
            </p>
          </div>

          <div className="bg-red-50 border-2 border-red-200 rounded-xl p-5 mb-8" data-id="element-138">
            <div className="flex items-center justify-center gap-2 mb-4 text-brand-red font-black text-sm sm:text-base uppercase tracking-wide" data-id="element-139">
              <Clock className="w-5 h-5" data-id="element-140" />
              <span data-id="element-141">
                🔥 Ultima occasione! Il prezzo aumenta allo scadere del timer.
              </span>
            </div>
            <div className="flex justify-center gap-3 sm:gap-6" data-id="element-142">
              <div className="text-center" data-id="element-143">
                <div className="bg-brand-dark text-white text-3xl sm:text-4xl font-black px-4 py-3 rounded-lg shadow-inner min-w-[70px]" data-id="element-144">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
                <p className="text-xs font-black text-brand-dark mt-2 tracking-widest uppercase" data-id="element-145">
                  ORE
                </p>
              </div>
              <div className="text-3xl font-black text-gray-300 mt-2" data-id="element-146">:</div>
              <div className="text-center" data-id="element-147">
                <div className="bg-brand-dark text-white text-3xl sm:text-4xl font-black px-4 py-3 rounded-lg shadow-inner min-w-[70px]" data-id="element-148">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </div>
                <p className="text-xs font-black text-brand-dark mt-2 tracking-widest uppercase" data-id="element-149">
                  MINUTI
                </p>
              </div>
              <div className="text-3xl font-black text-gray-300 mt-2" data-id="element-150">:</div>
              <div className="text-center" data-id="element-151">
                <div className="bg-brand-dark text-white text-3xl sm:text-4xl font-black px-4 py-3 rounded-lg shadow-inner min-w-[70px]" data-id="element-152">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </div>
                <p className="text-xs font-black text-brand-dark mt-2 tracking-widest uppercase" data-id="element-153">
                  SECONDI
                </p>
              </div>
            </div>
          </div>

          <CTAButton href="https://yoga-pro.impultienda.ar/checkout" className="w-full sm:w-auto sm:px-16" data-id="element-154">
            🚀 SÌ, VOGLIO IL PACK 6 IN 1
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm sm:text-base text-brand-dark font-bold" data-id="element-155">
          <div className="flex items-center gap-2" data-id="element-156">
            <Star className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-157" />
            <span data-id="element-158">4.9/5 — Recensioni Verificate</span>
          </div>
          <span className="hidden sm:inline text-gray-400" data-id="element-159">•</span>
          <div className="flex items-center gap-2" data-id="element-160">
            <ShieldCheck className="w-5 h-5 text-brand-green" data-id="element-161" />
            <span data-id="element-162">Garanzia 7 Giorni — Zero Rischio</span>
          </div>
        </div>
      </div>
    </section>;
}